import React from 'react'
import { Link } from 'components/link'
import { Helmet } from 'react-helmet'
import { DI } from 'modules'
import PageSubmenu from 'components/page-submenu'

import { livesList } from 'config/routes'

function Empty(props) {
  const strings = props.common.strings
  return (
    <section className="content">
      <Helmet title={`${props.pageTitle} - ${strings['site.title']} Live`} />
      <div className="iwrap ae-empty-page">
        <div className="ae-empty-top">
          <PageSubmenu items={props.submenu} />
          <div className="page-subtitle">
            {strings['page.my_event.empty.subtitle']}
          </div>
          <div className="page-notice-text">
            {strings['page.my_event.empty.notice_text_1']}
            <Link to={livesList.getPath()}>
              {strings['page.my_event.empty.notice_link']}
            </Link>
            {strings['page.my_event.empty.notice_text_2']}
          </div>
        </div>
        <div className="ae-empty" />
      </div>
    </section>
  )
}

export default DI()(Empty)
